import common from '@/store/common/mutations';
import * as types from './mutation-types';

import { SEARCH_PARAMS, CMPN_MST_POPUP, PAGING_INFO, OP_CD_SEARCH_PARAMS, POP_UP_PAGING_INFO } from './state';
const getInit = () => {
	return {
		searchParams: {
			cmpnNo: null /*캠페인명*/,
			partNm: null /*원인부품명*/,
			cmpnType: null /* 캠페인유형 */
		},
		cmpnMstList: [],
		excelDownLoadList: [], //엑셀다운로드시 해더저장
		causCdListPop: [], //원인코드 콤보박스
		prbmTypeListPop: [], //문제유형 콤보박스
		cmpnTypeListPop: [], //캠페인유형 콤보박스
		tymaCdListPop: [], //기종 콤보박스

		opCodeList: [], //op코드 리스트
		pmcIdList: [], //PMC Id.리스트
		cmpnPartList: [], //교환부품 리스트
		popUpOpCdList: [], //팝업 OP코드 리스트

		pagingInfo: {
			currentPage: 1,
			endPage: 1,
			pageUnit: 30,
			startPage: 1,
			totalSize: 1
		},
		popupParams: {
			show: false,
			selectedRow: {},
			opCd: '',
			lts: '',
			mtrlCst: '',
			stdCst: ''
		},
		opCdSearchParams: {
			opCd: '', //op코드
			partNo: '' //원인부품명
		},
		popUpPagingInfo: {
			currentPage: 1,
			endPage: 1,
			pageUnit: 30,
			startPage: 1,
			totalSize: 1
		},
		cmpnMstPopup: {
			deleteBtn: false, //삭제버튼권한
			cmpnNo: '', //캠페인번호
			cmpnNm: '', //캠페인명
			prbmType: '', //문제유형
			prbmTypeNm: '', //
			cmpnType: '', //캠페인유형
			cmpnTypeNm: '', //
			strtDd: '', //시작일
			endDd: '', //종료일
			occuRegn: '', //발생지역
			occuRegnNm: '', //
			dtlRegn: '', //세부지역
			subjQty: '', //
			vehlCd: '', //차종
			tymaCd: '', //기종
			tymaCdNm: '', //
			prdtStrtDd: '', //
			prdtEndDd: '', //
			cpnyCd: '', //딜러점코드
			cpnyNm: '', //딜러점명
			causPartNo: '', //원인부품번호
			causPartNm: '', //원인부품명
			causCd: '', //원인코드
			causNm: '', //
			phmnCd: '', //현상코드
			phmnNm: '', //현상코드명
			phmnSbc: '', //현상내용
			dlvgNm: '', //실납품사
			cmpnQty: '', //처리수량
			procRt: '', //처리율
			readOnlyAuth: false //리드온리구분값
		}
	};
};

export default {
	...common,
	[types.SET]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit()); //
	},
	[types.STATE_CMPN_MST_INIT]: state => {
		state.cmpnMstPopup = CMPN_MST_POPUP(); //디테일 조회

		state.opCodeList = [];
		state.pmcIdList = [];
		state.cmpnPartList = [];

		(state.occuRegnListPop = []), //발생지역 콤보박스
			(state.causCdListPop = []), //원인코드 콤보박스
			(state.prbmTypeListPop = []), //문제유형 콤보박스
			(state.cmpnTypeListPop = []), //캠페인유형 콤보박스
			(state.tymaCdListPop = []); //기종 콤보박스
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.POP_UP_PAGING_INFO]: (state, { key, value }) => {
		state.popUpPagingInfo[key] = value;
	},
	[types.CMPN_MST_POPUP]: (state, { key, value }) => {
		state.cmpnMstPopup[key] = value;
	},
	[types.OP_CD_SEARCH_PARAMS]: (state, { key, value }) => {
		state.opCdSearchParams[key] = value;
	},
	[types.OP_CD_SEARCH_PARAMS_INIT]: state => {
		state.opCdSearchParams = OP_CD_SEARCH_PARAMS();
		state.popUpPagingInfo = POP_UP_PAGING_INFO();
	}
};
